// extracted by mini-css-extract-plugin
export default {"PersonalizationElements":"PersonalizationElements_PersonalizationElements__pxthB"};